window.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".section-ticker .swiper", {
    slidesPerView: "auto",
    loop: true,
    freeMode: true,
    speed: 12000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });
});
